'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIDescriptionList from 'UIComponents/list/UIDescriptionList';
import UIList from 'UIComponents/list/UIList';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { getFormattedUrl, getHubSpotAcceptableUseUrl, getHubSpotTermsOfServiceUrl, getHubSpotPrivacyUrl } from '../../../../utils/urls';
import { getLangCode } from '../../../../selectors/auth';
const I18N_PATH = 'appMarketplace.detail.overview.sidebar.privacy';

const Link = props => /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
  external: true,
  iconProps: {
    className: 'hidden'
  }
}));

const Privacy = ({
  homemade,
  onTrackInteraction,
  privacyUrl,
  privacy2Url,
  privacy3Url,
  termsUrl
}) => {
  const langCode = useSelector(getLangCode);
  const trackInteraction = useCallback(action => onTrackInteraction(action, 'data privacy'), [onTrackInteraction]);
  const trackOtherPrivacyPolicyLinkClick = useCallback(() => trackInteraction('click other privacy policy link'), [trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `${I18N_PATH}.dataEnrichmentNotice_jsx`,
        options: {
          aupLink: {
            href: getHubSpotAcceptableUseUrl(langCode),
            onClick: () => {
              trackInteraction('click acceptable use policy link');
            }
          },
          tosLink: {
            href: getHubSpotTermsOfServiceUrl(langCode),
            onClick: () => {
              trackInteraction('click customer terms of service link');
            }
          }
        },
        elements: {
          Link
        }
      })
    }), /*#__PURE__*/_jsxs(UIDescriptionList, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.privacyPolicyLabel`
        })
      }), homemade ? /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `${I18N_PATH}.privacyPolicyHomemade_jsx`,
          options: {
            privacyPolicyLink: {
              href: getHubSpotPrivacyUrl(langCode),
              onClick: () => {
                trackInteraction('click product privacy policy link');
              }
            }
          },
          elements: {
            Link
          }
        })
      }) : /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `${I18N_PATH}.privacyPolicy_jsx`,
          options: {
            privacyLinkProps: {
              href: getFormattedUrl(privacyUrl),
              onClick: () => trackInteraction('click privacy policy link')
            },
            tosLinkProps: {
              href: getFormattedUrl(termsUrl),
              onClick: () => trackInteraction('click terms link')
            }
          },
          elements: {
            Link
          }
        })
      }), /*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.dataHostingLocationLabel`
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.dataHostingLocationNotice`
        })
      }), (privacy2Url || privacy3Url) && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${I18N_PATH}.additionalPrivacyInformationLabel`
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsxs(UIList, {
            children: [privacy2Url && /*#__PURE__*/_jsx(Link, {
              href: getFormattedUrl(privacy2Url),
              onClick: trackOtherPrivacyPolicyLinkClick,
              children: /*#__PURE__*/_jsx(UITruncateString, {
                children: privacy2Url
              })
            }), privacy3Url && /*#__PURE__*/_jsx(Link, {
              href: getFormattedUrl(privacy3Url),
              onClick: trackOtherPrivacyPolicyLinkClick,
              children: /*#__PURE__*/_jsx(UITruncateString, {
                children: privacy3Url
              })
            })]
          })
        })]
      })]
    })]
  });
};

Privacy.propTypes = {
  homemade: PropTypes.bool.isRequired,
  onTrackInteraction: PropTypes.func.isRequired,
  privacyUrl: PropTypes.string.isRequired,
  privacy2Url: PropTypes.string,
  privacy3Url: PropTypes.string,
  termsUrl: PropTypes.string.isRequired
};
export default Privacy;